import { render } from "./SeVerticalTab.vue?vue&type=template&id=0c592b94&scoped=true&ts=true"
import script from "./SeVerticalTab.vue?vue&type=script&lang=ts"
export * from "./SeVerticalTab.vue?vue&type=script&lang=ts"

import "./SeVerticalTab.vue?vue&type=style&index=0&id=0c592b94&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c592b94"]])

export default __exports__